import { useState } from 'react';
import { useLang } from '../context/LanguageContext';

const TargetWeightStep = ({ current, unit = 'lbs', value, onSave }) => {
  const [target, setTarget] = useState(value || '');
  const { t } = useLang();

  const isValid = parseFloat(target) > 0;

  return (
    <div className="max-w-md mx-auto">
      {current && (
        <div className="mb-6 text-center text-white/70">
          {t('currentWeightLabel')} <span className="text-white font-semibold">{current} {unit}</span>
        </div>
      )}
      <div className="relative">
        <input
          type="number"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          placeholder={`${t('enterTargetWeight')} ${unit}`}
          className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors"
          data-testid="target-weight-input"
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 text-sm">{unit}</span>
      </div>
      <button
        onClick={() => onSave(target)}
        disabled={!isValid}
        className={`mt-8 w-full py-3.5 rounded-sm font-bold uppercase tracking-wide transition-all ${
          !isValid
            ? 'bg-[#2a2b2f] text-white/40 cursor-not-allowed'
            : 'bg-[#ff4e15] hover:bg-[#ff6033] text-white pulse-orange'
        }`}
        data-testid="target-weight-continue-btn"
      >
        {t('continue')}
      </button>
    </div>
  );
};

export default TargetWeightStep;
